import { useEffect } from 'react';
import { Alert, Badge, ListGroup } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { CommonRoot } from '../../../../CompUtils/CommonRoot';
import FullLoading from '../../../../CompUtils/FullLoading';
import { getPostulacionesPuesto, usePostulacionesPuesto } from '../restPostulacionesPuesto';

const ListadoPuestos = () => {
  const concurso = useConcurso();
  const { idLlamadoConcurso, esCoordinadorConcursal } = concurso;
  const { postulacionesPuesto, loading } = usePostulacionesPuesto();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPostulacionesPuesto({ idLlamadoConcurso }));
  }, []);
  return (
    <>
      <FullLoading show={loading} />
      <CommonRoot>
        <ListGroup variant="flush">
          {postulacionesPuesto?.length > 0 ? (
            postulacionesPuesto.map(
              ({
                agrupamiento,
                capacidadTerciaria,
                denominacion,
                funcionEspecifica,
                idPuesto,
                nivel,
                reserva,
                ubicacion,
                cantidadPostulantesAceptados,
                cantidadPostulantesRechazados,
              }) => {
                return (
                  <ListGroup.Item
                    key={idPuesto}
                    as="li"
                    className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">
                        {idPuesto}- {ubicacion} - {denominacion} - {agrupamiento} - {nivel} -
                        {reserva ? 'Con Reserva' : 'Sin Reserva'} -{' '}
                        {capacidadTerciaria ? 'Con Cap. Terc.' : 'Sin Cap. Terc'} -{' '}
                        {funcionEspecifica ? 'Con Func. Espec.' : 'Sin Func. Espec.'}
                      </div>
                      {esCoordinadorConcursal && (
                        <Link to={`postulaciones/detalle_postulantes/${idPuesto}`}>Detalles</Link>
                      )}
                    </div>
                    <Badge variant="primary" pill>
                      {cantidadPostulantesRechazados + cantidadPostulantesAceptados}
                    </Badge>
                  </ListGroup.Item>
                );
              },
            )
          ) : (
            <Alert variant="danger">No hay puestos para mostrar</Alert>
          )}
        </ListGroup>
      </CommonRoot>
    </>
  );
};

export default ListadoPuestos;
